<div class="card" [ngClass]="{disabled: disabled, greyed: greyed, 'new-location': isNewLocation}" [routerLink]="disabled ? null : link" (click)="track_find_location()">
	<div class="image-container">
		<img *ngIf="!!image" [alt]="alt" [src]="image" width="100%">
		<span class="badge" *ngIf="!!tag && !isNewLocation">
			<img src="/assets/branch-grid/star.svg" alt="" class="badge-icon"> Special offers
		</span>
		<span class="badge" *ngIf="isNewLocation">
			<img src="/assets/branch-grid/vector.svg" alt="" class="badge-icon"> Opening September
		</span>
	</div>
	<div class="content">
		<div class="name-row">
			<p class="name">{{title}} <span *ngIf="!!area" class="divider"></span><span *ngIf="!!area" class="area">{{area}}</span></p>
		</div>
		<p class="location">
			<img src="/assets/branch-grid/location_on.svg" alt="" class="location-icon">
			<span><ng-content></ng-content></span>
		</p>
		<p class="select">
			<ng-container *ngIf="link && !disabled">
				<a [routerLink]="link" (click)="track_find_location()">{{linkText}}</a>
			</ng-container>
			<ng-container *ngIf="!link || disabled">
				{{linkText}}
			</ng-container>
		</p>
	</div>
	<div class="disabled-overlay" *ngIf="disabled"></div>
</div>
